import React, { useState, useEffect } from "react";
import { TextField, Box, Autocomplete } from "@mui/material";
import { UseProduct } from "./UseProduct";

export default function SearchCom(props) {
  const { GetProductsByWord } = UseProduct();
  const [open, setOpen] = useState(false);
  const [productsByWordRes, setProductsByWordRes] = useState();
  const [nameSuggestion, setNameSuggestion] = useState({
    q: "",
    open: false,
    selected: "",
  });

  useEffect(() => {
    if (nameSuggestion && nameSuggestion.q.length > 0) {
      GetProductsByWord(
        nameSuggestion.q.replace(/^\s+/, ""),
        (productsByWordRes) => {
          setProductsByWordRes(productsByWordRes);
        }
      );
    }
  }, [nameSuggestion.q]);

  useEffect(() => {
    if (productsByWordRes && productsByWordRes.length > 0) {
      if (nameSuggestion.q.length > 0) {
        setNameSuggestion({ ...nameSuggestion, open: true });
      }
    }
  }, [productsByWordRes]);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Autocomplete
        fullWidth
        freeSolo
        filterOptions={(options, state) => options}
        onChange={(evt, value) => {
          setNameSuggestion({
            ...nameSuggestion,
            selected: value.faName,
            open: false,
            q: "",
          });
          props.setState({
            ...props.state,
            enName: value.enName,
            faName: value.faName,
          });
        }}
        open={nameSuggestion.open}
        onBlur={() => {
          setNameSuggestion({ ...nameSuggestion, open: false });
        }}
        disableClearable
        clearOnEscape
        inputValue={props.state.faName ? props.state.faName : ""}
        size="small"
        options={productsByWordRes ? productsByWordRes : []}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) => option.faName}
        renderInput={(params) => (
          <TextField
            {...params}
            error={props.stateValidation}
            variant="outlined"
            fullWidth
            onChange={(evt) => {
              props.setState({ ...props.state, faName: evt.target.value });
            }}
            InputProps={{
              ...params.InputProps,
              onKeyDown: (e) => {
                if (e.key === "Enter" && !open) {
                  e.stopPropagation();
                  setNameSuggestion({
                    ...nameSuggestion,
                    q: props.state.faName,
                    selected: "",
                  });
                }
              },
            }}
            autoFocus={true}
            label="نام فارسی"
          />
        )}
      />
    </Box>
  );
}
